import type { ClientLocationPlan } from "api-types/locationPlans/locationPlansResponses";
import type { ClientLocationWithLevel } from "api-types/locations/locationBaseTypes";
import type { ClientMasterPlanHydrated } from "api-types/masterPlans/masterPlansResponses";
import type { JSX } from "react";
import { SimpleDropDownMenu } from "ui/components/DropdownMenu";
import {
  editShowroomIntroPath,
  locationPlanShowroomPath,
  procurePath,
  showroomIntroPath,
  studioPath,
} from "../../../../routeHelpers";
import usePlanOverflowMenuItems from "../../hooks/usePlanOverflowMenuItems";

interface LocationPlanMenuItemsProps {
  location: ClientLocationWithLevel;
  locationId: string;
  locationPlanId: string;
  communityPlan: ClientLocationPlan | undefined;
  masterPlan: ClientMasterPlanHydrated | undefined;
  builderId: string;
  onArchivePlan?: (() => void) | null;
  onUnarchivePlan?: (() => void) | null;
}

export default function LocationPlanMenuItems({
  location,
  locationId,
  locationPlanId,
  communityPlan,
  masterPlan,
  builderId,
  onArchivePlan,
  onUnarchivePlan,
}: LocationPlanMenuItemsProps): JSX.Element | null {
  const menuItems = usePlanOverflowMenuItems({
    communityPlanId: locationPlanId,
    communityPlan,
    masterPlan,
    location,
    publicPlanType: "community_plans",
    showroomPath: locationPlanShowroomPath(builderId, locationId, locationPlanId),
    showroomIntroPath: showroomIntroPath("community_plans", builderId, locationPlanId),
    editShowroomIntroPath: editShowroomIntroPath("community_plans", builderId, locationPlanId),
    procurePath: procurePath({
      builderId,
      communityPlanId: locationPlanId,
    }),
    studioPath: masterPlan ? studioPath(masterPlan.studioDocId, builderId) : undefined,
    onArchivePlan,
    onUnarchivePlan,
  });

  if (!communityPlan) {
    console.warn(
      `LocationPlanMenuItems: communityPlan is undefined for locationPlanId=${locationPlanId}, locationId=${locationId}. This indicates a bad data state.`,
    );
    return null;
  }

  return <SimpleDropDownMenu menuItems={menuItems} ellipsisSize={16} />;
}
